/**
 * Mobile product cards — swipe deck (≤743px only).
 */
(function () {
  var SWIPE_THRESHOLD = 60;
  var MAX_WIDTH = 743;
  var DECK_FADE_OUT_MS = 200;
  var DECK_FADE_IN_MS = 350;
  var SWIPE_EXIT_MS = 400;

  function isMobileViewport() {
    return window.matchMedia('(max-width: ' + MAX_WIDTH + 'px)').matches;
  }

  function formatButtonLabel(template, count) {
    var label = template.replace(/\{count\}/g, String(count));
    if (count === 1) {
      label = label.replace(/\bswipes\b/gi, 'swipe').replace(/\bslides\b/gi, 'slide');
    }
    return label;
  }

  function initMobileDeck(root) {
    var stack = root.querySelector('.product-cards-mobile__stack');
    var cards = stack ? Array.prototype.slice.call(stack.querySelectorAll('.product-cards-mobile__card')) : [];
    var total = cards.length;
    var dots = Array.prototype.slice.call(root.querySelectorAll('.product-cards-mobile__dot'));
    var cta = root.querySelector('.product-cards-mobile__cta');

    if (!cards.length || !stack) return;

    var currentIndex = 0;
    var isAnimating = false;

    var template = cta ? cta.getAttribute('data-template') || '' : '';
    var expiredLabel = cta ? cta.getAttribute('data-expired-label') || '' : '';
    var expiredLink = cta ? cta.getAttribute('data-expired-link') || '' : '';
    var buttonLink = cta ? cta.getAttribute('data-button-link') || '' : '';

    function clearCardState(card) {
      card.classList.remove(
        'is-gone',
        'is-out-left',
        'is-out-right',
        'is-active',
        'is-dragging'
      );
      card.style.transform = '';
    }

    function updateStackPositions() {
      cards.forEach(function (card, i) {
        var stackIndex = i - currentIndex;
        var isHidden = i < currentIndex || stackIndex >= 5;
        card.classList.toggle('is-gone', isHidden);
        card.classList.toggle('is-active', i === currentIndex && !isHidden);
        card.setAttribute('data-stack-index', String(stackIndex));
      });
    }

    function updateDots() {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentIndex);
      });
    }

    function updateCta() {
      if (!cta) return;

      var remaining = total - currentIndex - 1;

      if (currentIndex >= total - 1) {
        cta.classList.add('is-expired');
        cta.textContent = expiredLabel;
        if (expiredLink) {
          cta.setAttribute('href', expiredLink);
        }
        return;
      }

      cta.classList.remove('is-expired');
      cta.textContent = formatButtonLabel(template, remaining);
      if (buttonLink) {
        cta.setAttribute('href', buttonLink);
      }
    }

    function setIndex(nextIndex) {
      currentIndex = nextIndex;
      updateStackPositions();
      updateDots();
      updateCta();
    }

    function getActiveCard() {
      return cards[currentIndex] || null;
    }

    function resetDeckState() {
      currentIndex = 0;
      cards.forEach(clearCardState);
      if (cards[0]) {
        cards[0].classList.add('is-active');
      }
      updateStackPositions();
      updateDots();
      updateCta();
    }

    function resetDeckWithFade() {
      stack.classList.add('is-deck-fading-out');

      window.setTimeout(function () {
        resetDeckState();
        stack.classList.remove('is-deck-fading-out');
        stack.classList.add('is-deck-fading-in');

        window.setTimeout(function () {
          stack.classList.remove('is-deck-fading-in');
          isAnimating = false;
        }, DECK_FADE_IN_MS);
      }, DECK_FADE_OUT_MS);
    }

    function onSwipeComplete(card, isLastCard) {
      card.classList.remove('is-out-left', 'is-out-right');
      card.classList.remove('is-active', 'is-dragging');
      card.style.transform = '';

      if (isLastCard) {
        resetDeckWithFade();
        return;
      }

      setIndex(currentIndex + 1);
      isAnimating = false;
    }

    function goNext(direction) {
      var card = getActiveCard();
      if (!card) return;
      if (total <= 1) {
        resetDrag(card);
        return;
      }

      var isLastCard = currentIndex >= total - 1;

      isAnimating = true;
      card.classList.remove('is-dragging');
      card.classList.add(direction < 0 ? 'is-out-left' : 'is-out-right');

      var onEnd = function (e) {
        if (e.propertyName !== 'transform' && e.propertyName !== 'opacity') return;
        card.removeEventListener('transitionend', onEnd);
        onSwipeComplete(card, isLastCard);
      };

      card.addEventListener('transitionend', onEnd);

      window.setTimeout(function () {
        if (isAnimating) {
          card.removeEventListener('transitionend', onEnd);
          onSwipeComplete(card, isLastCard);
        }
      }, SWIPE_EXIT_MS);
    }

    function dismissCard(direction) {
      if (isAnimating || !direction) return;
      goNext(direction);
    }

    function resetDrag(card) {
      card.classList.remove('is-dragging');
      card.style.transform = '';
      updateStackPositions();
    }

    function bindPointer(card) {
      var startX = 0;
      var startY = 0;
      var deltaX = 0;
      var tracking = false;

      function onStart(clientX, clientY) {
        if (!isMobileViewport() || isAnimating) return;
        if (!card.classList.contains('is-active')) return;

        startX = clientX;
        startY = clientY;
        deltaX = 0;
        tracking = true;
        card.classList.add('is-dragging');
      }

      function onMove(clientX, clientY) {
        if (!tracking) return;

        deltaX = clientX - startX;
        var deltaY = clientY - startY;

        if (Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaX) < 10) {
          return;
        }

        var rotate = deltaX * 0.08;
        card.style.transform = 'translateX(' + deltaX + 'px) rotate(' + rotate + 'deg)';
      }

      function onEnd() {
        if (!tracking) return;
        tracking = false;

        if (deltaX <= -SWIPE_THRESHOLD) {
          dismissCard(-1);
          return;
        }

        if (deltaX >= SWIPE_THRESHOLD) {
          dismissCard(1);
          return;
        }

        resetDrag(card);
      }

      card.addEventListener(
        'touchstart',
        function (e) {
          if (e.touches.length !== 1) return;
          onStart(e.touches[0].clientX, e.touches[0].clientY);
        },
        { passive: true }
      );

      card.addEventListener(
        'touchmove',
        function (e) {
          if (!tracking || e.touches.length !== 1) return;
          onMove(e.touches[0].clientX, e.touches[0].clientY);
        },
        { passive: true }
      );

      card.addEventListener('touchend', onEnd);
      card.addEventListener('touchcancel', onEnd);

      card.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        card.setPointerCapture(e.pointerId);
        onStart(e.clientX, e.clientY);
      });

      card.addEventListener('pointermove', function (e) {
        if (e.pointerType === 'touch') return;
        onMove(e.clientX, e.clientY);
      });

      card.addEventListener('pointerup', function (e) {
        if (e.pointerType === 'touch') return;
        onEnd();
      });

      card.addEventListener('pointercancel', function (e) {
        if (e.pointerType === 'touch') return;
        onEnd();
      });
    }

    updateStackPositions();
    updateDots();
    updateCta();

    cards.forEach(bindPointer);
  }

  function init() {
    if (!isMobileViewport()) return;

    var roots = document.querySelectorAll('.product-cards__mobile');
    roots.forEach(initMobileDeck);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
